/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import { emailTablehead, leftTableHead, rightTableHead } from './tablehead';
import { TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../SharedModules/CommonUtilities/commonUtilities';
import {
  getEmailList,
  getEmailLogDetail,
  emailLogDetailData,
  emailLogRightGrid,
  saveLogEmail,
  saveEmailogData,
  errorLeftRightGrid,
  getEmailTypeAvailableList,
  emailListData,
  getEmailListCheckCall,
  dispatchSaveList,
  dispatchDeleteList,
} from './store/action';
import {
  errorMessageAtleast,
  systemSuccessMsg,
  codeDomainList,
} from './ConstantData';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

const AddorDeleteLoadLogEmail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [load, setLoad] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [leftFull, setLefFull] = React.useState(false);
  const [rightFull, setRightFull] = React.useState(false);
  const [emailListFull, setEmailListFull] = React.useState(false);
  const [emailListTbl, setEmailListTbl] = React.useState([]);
  const [emailTypeAssignedTbl, setEmailTypeAssignedTbl] = React.useState([]);
  const [emailTypeAvailableTbl, setEmailTypeAvailableTbl] = React.useState([]);
  const [rightEmailgridTbl, setRightEmailgridTbl] = React.useState([]);
  const [leftEmailgridTbl, setLeftEmailgridTbl] = React.useState([]);
  const [gridParams, setGridParams] = React.useState(null);
  const [sucessMessage, setSucessMessage] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState([]);
  const [selectedRowEmail, setSelectedRowEmail] = React.useState('');
  const [newSelectedEmail, setNewSelectedEmail] = React.useState('');
  const [saveEmailPayload, setSaveEmailPayload] = React.useState([]);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [disableSaveCancel, setDisableSaveCancel] = React.useState(false);
  const [isEdited, setIsEdited] = React.useState(false);
  const [pendingLeftGridUpdate, setPendingLeftGridUpdate] = React.useState(null);
  const [pendingEmailLogDetail, setPendingEmailLogDetail] = React.useState(null);
  const[resetAllField,setResetAllField]= useState(true)
  const [pendingEmailListUpdate, setPendingEmailListUpdate] = React.useState(null);
  const errorMessageDispatch = errorMessageAtleast;
  const email_list = useSelector(
    (state) => state?.sharedState?.AddorDeleteLoadLogEmailReducer?.email_list
  );
  const email_list_check = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.email_list_check
  );
  const email_log_detail = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.email_log_detail
  );
  const email_right_grid = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.email_right_grid
  );
  const save_email_log = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.save_email_log
  );
  const error_left_right_tbl = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.error_left_right_tbl
  );
  const email_available_list = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.email_available_list
  );
  const save_payload_list = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.save_payload_list
  );
  const delete_payload_list = useSelector(
    (state) =>
      state?.sharedState?.AddorDeleteLoadLogEmailReducer?.delete_payload_list
  );
  // save payload list and delete payload list
  React.useEffect(() => {
    if (save_payload_list && delete_payload_list) {
      if (save_payload_list.length != 0 || delete_payload_list.length != 0) {
        checkValidDataOrNot();
      }
    }
  }, [save_payload_list, delete_payload_list]);
  // after add or delete succuess message
  React.useEffect(() => {
    if (save_email_log === 'success') {
      setDisableSaveCancel(false);
      dispatch(dispatchSaveList([]));
      dispatch(dispatchDeleteList([]));
      setSucessMessage([systemSuccessMsg]);
      setLoad(false);
      setIsEdited(false);
      dispatch(getEmailList(true));
      setLoad(true);
    } else if (save_email_log === 'closeTab') {
      dispatch(saveEmailogData([]));
      setIsEdited(false);
      setDisableSaveCancel(false);
      dispatch(emailListData([], true));
      dispatch(dispatchSaveList([]));
      dispatch(dispatchDeleteList([]));
      setSucessMessage([]);
      setErrorMessage([]);
      setOpenCancel(false);
      closeTab('/addordeleteloadlogemail', history, dispatch);
    } else {
      setSucessMessage([]);
    }
  }, [save_email_log]);
  // move left or right clicks error messages
  React.useEffect(() => {
    if (error_left_right_tbl === errorMessageAtleast) {
      setErrorMessage([error_left_right_tbl]);
    } else {
      setErrorMessage([]);
    }
  }, [save_email_log]);
  // get email list here
  React.useEffect(() => {
    handleScrollToEvent();
    if (email_list?.length != 0) {
      setLoad(false);
      setEmailListTbl(email_list);
      checkValidDataOrNot();
    } else {
      dispatch(getEmailList(true));
      // dispatch(getEmailListCheckCall(true));
      setLoad(true);
    }
  }, [email_list]);
  // get email type assigned table grid here
  React.useEffect(() => {
    if (email_log_detail?.length != 0) {
      if (isEdited) {
        let newObj = [];
        if (save_payload_list?.length != 0) {
          let save_payload_list_update = save_payload_list.forEach((obj) => {
            let emailKeyName = Object.keys(obj);
            if (
              email_log_detail?.length === 1 &&
              email_log_detail[0]?.emailAdd === '' &&
              email_log_detail[0]?.emailType === ''
            ) {
              obj[selectedRowEmail] = [];
            }
            if (email_log_detail[0]?.emailAddr != emailKeyName[0]) {
              newObj.push(obj);
            }
          });
        }
        let saveEachList = [
          {
            [email_log_detail[0]?.emailAddr]: email_log_detail,
          },
        ];
        dispatch(dispatchSaveList([...saveEachList, ...newObj]));
      }

      setEmailTypeAssignedTbl([...email_log_detail]);
      dispatch(getEmailTypeAvailableList({ codeDomainList: codeDomainList }));
      setLoad(false);
    } else if (email_log_detail?.length === 0) {
      setLoad(false);
      setEmailTypeAssignedTbl([]);
    } else {
      setEmailTypeAssignedTbl([]);
    }
  }, [email_log_detail]);
  // get email type available table grid here
  React.useEffect(() => {
    if (email_right_grid?.length != 0) {
      if (isEdited) {
        let newObj = [];
        if (delete_payload_list?.length != 0) {
          let delete_payload_list_update = delete_payload_list.forEach(
            (obj) => {
              let emailKeyName = Object.keys(obj);
              if (
                email_right_grid?.length === 1 &&
                email_right_grid[0]?.emailAdd === '' &&
                email_right_grid[0]?.emailType === ''
              ) {
                obj[selectedRowEmail] = [];
              }
              if (email_right_grid[0]?.emailAddr != emailKeyName[0]) {
                newObj.push(obj);
              }
            }
          );
        }
        let deleteEachList = [
          {
            [email_right_grid[0]?.emailAddr]: email_right_grid,
          },
        ];
        dispatch(dispatchDeleteList([...deleteEachList, ...newObj]));
      }

      setEmailTypeAvailableTbl(email_right_grid);
    } else {
      setEmailTypeAvailableTbl([]);
    }
  }, [email_right_grid]);
  // get default email type available list here
  React.useEffect(() => {
    if (email_available_list && email_available_list?.length != 0) {
      setLoad(false);
      let results = filterByReference(email_available_list, email_log_detail);
      let filterAvList = [];
      let emailAvData = results?.forEach((obj) => {
        let emailList = {
          emailType: obj?.codeValueID?.codeValue,
          emailAddr: selectedRowEmail,
        };
        filterAvList.push(emailList);
      });
      setEmailTypeAvailableTbl(filterAvList);
    } else if (email_available_list && email_available_list?.length === 0) {
      setLoad(false);
    }
  }, [email_available_list]);
  const filterByReference = (arr1, arr2) => {
    let res = [];
    res = arr1?.filter((el) => {
      return !arr2?.find((element) => {
        return element.emailType === el?.codeValueID?.codeValue;
      });
    });
    return res;
  };
  // email list table change function
  const onSelectionChangedEmail = (params) => {
    dispatch(emailLogRightGrid([]));
    dispatch(emailLogDetailData([]));
    setRightEmailgridTbl([]);
    setLeftEmailgridTbl([]);
    dispatch(errorLeftRightGrid([]));
    const selectedRows = params?.api?.getSelectedRows();
    let payloadObj = {
      emailAddr: [selectedRows[0]?.email],
    };
    setSelectedRowEmail(selectedRows[0]?.email);
    let emailObjFind = false;
    let findEmailElement = save_payload_list?.forEach((obj) => {
      if (obj[selectedRows[0]?.email]) {
        // setTimeout(
        //   () => dispatch(emailLogDetailData(obj[selectedRows[0]?.email])),
        //   10
        // );
        setPendingEmailLogDetail(obj[selectedRows[0]?.email]);

        emailObjFind = true;
      } else {
        setLoad(true);


        dispatch(getEmailTypeAvailableList({ codeDomainList: codeDomainList }));
      }
    });
    if (!emailObjFind) {
      if (selectedRows[0]?.email && !selectedRows[0]?.emailNew) {
        dispatch(getEmailLogDetail(payloadObj));
        setLoad(true);
        dispatch(saveEmailogData([]));
      } else {
        setLoad(true);
        dispatch(getEmailTypeAvailableList({ codeDomainList: codeDomainList }));
      }
    }
  };
  // right grid ready
  const onRightGridReady = (params) => {};
  const onLeftAssignedGridReady = (params) => {};
  // left grid ready
  const onLeftGridReady = (params) => {
    setGridParams(params);
    // setTimeout(
    //   () =>
    //     params.api.forEachNode(
    //       (node) => node.rowIndex === 0 && node.setSelected(true)
    //     ),
    //   1000
    // );
  };
  // move left from email type available table grid
  const moveToLeft = () => {
    setIsEdited(true);
    dispatch(saveEmailogData([]));
    dispatch(errorLeftRightGrid([]));
    if (leftEmailgridTbl[0]?.emailAddr === '') {
      leftEmailgridTbl.forEach((dataObj) => {
        dataObj.emailAddr = newSelectedEmail;
      });
    }
    if (leftEmailgridTbl?.length != 0) {
      setLoad(true);
      dispatch(emailLogDetailData(leftEmailgridTbl));
      getRightNewArray(leftEmailgridTbl);
      setLeftEmailgridTbl([]);
    } else {
      dispatch(errorLeftRightGrid(errorMessageDispatch));
    }
  };
  // move right from email type assigned table grid
  const moveToRight = () => {
    setIsEdited(true);
    dispatch(saveEmailogData([]));
    dispatch(errorLeftRightGrid([]));
    if (rightEmailgridTbl[0]?.emailAddr === '') {
      rightEmailgridTbl.forEach((dataObj) => {
        dataObj.emailAddr = newSelectedEmail;
      });
    }
    if (rightEmailgridTbl?.length != 0) {
      setLoad(true);
      dispatch(emailLogRightGrid(rightEmailgridTbl));
      getLeftNewArray(rightEmailgridTbl);
      setRightEmailgridTbl([]);
    } else {
      dispatch(errorLeftRightGrid(errorMessageDispatch));
    }
  };
  // create new array list for email type available table
  // const getLeftNewArray = (rightGrid) => {
  //   let newArrayList = emailTypeAssignedTbl;
  //   rightGrid.forEach((itemKey) => {
  //     removeObjectWithEmailType(newArrayList, itemKey.emailType);
  //   });
  //   dispatch(emailLogDetailData([]));
  //   if (newArrayList?.length != 0) {
  //     setTimeout(() => dispatch(emailLogDetailData(newArrayList)), 10);
  //   } else {
  //     dispatch(emailLogDetailData([{ emailAdd: '', emailType: '' }]));
  //     setTimeout(() => dispatch(emailLogDetailData(newArrayList)), 10);
  //   }
  //   setTimeout(() => setLoad(false), 1000);
  // };
  const getLeftNewArray = (rightGrid) => {
    let newArrayList = emailTypeAssignedTbl;
    rightGrid.forEach((itemKey) => {
      removeObjectWithEmailType(newArrayList, itemKey.emailType);
    });
    dispatch(emailLogDetailData([]));
    if (newArrayList?.length !== 0) {
      setPendingLeftGridUpdate(newArrayList);
    } else {
      dispatch(emailLogDetailData([{ emailAdd: '', emailType: '' }]));
      setPendingLeftGridUpdate(newArrayList);
    }
    setLoad(true); // Show spinner until update is done
  };
  // create new array list for email type assigned table
  // const getRightNewArray = (leftGrid) => {
  //   let newArrayList = emailTypeAvailableTbl;
  //   leftGrid.forEach((itemKey) => {
  //     removeObjectWithEmailType(newArrayList, itemKey.emailType);
  //   });
  //   dispatch(emailLogRightGrid([]));
  //   if (newArrayList?.length != 0) {
  //     console.log(newArrayList)
  //     setTimeout(() => dispatch(emailLogRightGrid(newArrayList)), 10);
  //   } else {
  //     dispatch(emailLogRightGrid([{ emailAdd: '', emailType: '' }]));
  //     setTimeout(() => dispatch(emailLogRightGrid(newArrayList)), 10);
  //   }
  //   setTimeout(() => setLoad(false), 1000);
  // };
  const getRightNewArray = (leftGrid) => {
    let newArrayList = emailTypeAvailableTbl;
    leftGrid.forEach((itemKey) => {
      removeObjectWithEmailType(newArrayList, itemKey.emailType);
    });
    dispatch(emailLogRightGrid([]));
    if (newArrayList?.length !== 0) {
      setPendingRightGridUpdate(newArrayList);
    } else {
      dispatch(emailLogRightGrid([{ emailAdd: '', emailType: '' }]));
      setPendingRightGridUpdate(newArrayList);
    }
    setLoad(true); }
  // remove duplicate array list function
  const removeObjectWithEmailType = (newArrayList, emailType) => {
    const objWithIdIndex = newArrayList.findIndex(
      (obj) => obj.emailType === emailType
    );
    if (objWithIdIndex > -1) {
      newArrayList.splice(objWithIdIndex, 1);
    }
    return newArrayList;
  };
  // on selection change on left grid
  const onSelectionChangedLeft = (params) => {
    dispatch(saveEmailogData([]));
    const selectedRows = params?.api?.getSelectedRows();
    setRightEmailgridTbl(selectedRows);
  };
  // on selection change on right grid
  const onSelectionChangedRight = (params) => {
    dispatch(saveEmailogData([]));
    const selectedRows = params?.api?.getSelectedRows();
    setLeftEmailgridTbl(selectedRows);
  };

  // save log email tyeps function
  const saveLogEmailDelete = (saveType) => {
    dispatch(getEmailListCheckCall(false));
    dispatch(saveEmailogData([]));
    dispatch(errorLeftRightGrid([]));
    let emailKeyFinalPayload = [];
    let addLoadEmailVo = save_payload_list?.forEach((obj) => {
      let emailKeyName = Object.keys(obj);
      let eachSavePayload = obj[emailKeyName[0]]?.forEach((objInside) => {
        if (objInside?.emailAddr) {
          emailKeyFinalPayload.push(objInside);
        }
      });
    });
    let emailKeyDeleteFinalPayload = [];
    let deleteLoadEmailVo = delete_payload_list?.forEach((obj) => {
      let emailKeyName = Object.keys(obj);
      let eachDeletePayload = obj[emailKeyName[0]]?.forEach((objInside) => {
        if (objInside?.emailAddr) {
          emailKeyDeleteFinalPayload.push(objInside);
        }
      });
    });
    let saveDeletePayload = {
      addLoadEmailVo: emailKeyFinalPayload,
      delloadEmailVo: emailKeyDeleteFinalPayload,
    };
    dispatch(saveLogEmail(saveDeletePayload, saveType));
    setLoad(true);
  };
  const handleAddNewRow = (params) => {
    setDisableSaveCancel(false);
    let obj = [
      {
        email: '',
        emailNew: true,
      },
    ];
    dispatch(emailListData(obj, false));
    onLeftGridReady(params)
    // setTimeout(() => onLeftGridReady(params), 100);
  };

  const checkValidDataOrNot = () => {
    let emailKeyFinalPayload = [];
    let addLoadEmailVo = save_payload_list?.forEach((obj) => {
      let emailKeyName = Object.keys(obj);
      let eachSavePayload = obj[emailKeyName[0]]?.forEach((objInside) => {
        if (objInside?.emailAddr) {
          emailKeyFinalPayload.push(objInside);
        }
      });
    });
    let emailKeyDeleteFinalPayload = [];
    let deleteLoadEmailVo = delete_payload_list?.forEach((obj) => {
      let emailKeyName = Object.keys(obj);
      let eachDeletePayload = obj[emailKeyName[0]]?.forEach((objInside) => {
        if (objInside?.emailAddr) {
          emailKeyDeleteFinalPayload.push(objInside);
        }
      });
    });
    if (
      emailKeyFinalPayload.length != 0 ||
      emailKeyDeleteFinalPayload.length != 0
    ) {
      setDisableSaveCancel(true);
    }
  };

  const deleteEmail = () => {
    setIsEdited(true);
    let newArrEmailList = email_list;
    let totalAvList = [];
    if (selectedRowEmail) {
      newArrEmailList = email_list.filter((object) => {
        return object.email !== selectedRowEmail;
      });
      let emailAvData = email_available_list?.forEach((obj) => {
        let emailList = {
          emailType: obj?.codeValueID?.codeValue,
          emailAddr: selectedRowEmail,
        };
        totalAvList.push(emailList);
      });
      let deleteEachList = [
        {
          [selectedRowEmail]: totalAvList,
        },
      ];
      dispatch(dispatchDeleteList([...delete_payload_list, ...deleteEachList]));
    } else {
      newArrEmailList.splice(-1);
    }
    dispatch(emailListData([{ email: '', emailType: '' }], true));
    // setTimeout(() => dispatch(emailListData(newArrEmailList, true)), 10);
    setPendingEmailListUpdate(newArrEmailList);
    onLeftGridReady(gridParams)
    // setTimeout(() => onLeftGridReady(gridParams), 100);
  };

  useEffect(()=>{
    if (gridParams) {
      gridParams.api.forEachNode(
        (node) => node.rowIndex === 0 && node.setSelected(false)
      )
    }
    setResetAllField(true)
  },[resetAllField])
  // handing reset All fields & data
  const resetAllFields = () => {
    setIsEdited(false);
    setDisableSaveCancel(false);
    dispatch(emailListData([], true));
    dispatch(dispatchSaveList([]));
    dispatch(dispatchDeleteList([]));
    setSucessMessage([]);
    setErrorMessage([]);
    handleScrollToEvent();
    setOpenCancel(false);
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj1 = updateTabs?.map((item) => {
      if (item.navTo === '/addordeleteloadlogemail') {
        item.isFormSave = false;
        item.isFormDirty = false;
        item.isFormError = false;
      }
      return item;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
  
    setResetAllField(false)
    // setTimeout(
    //   () =>
    //     gridParams.api.forEachNode(
    //       (node) => node.rowIndex === 0 && node.setSelected(false)
    //     ),
    //   100
    // );
    onLeftGridReady(gridParams)
    // setTimeout(() => onLeftGridReady(gridParams), 100);
  };
  // for disable save cancel update
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (email_list && Object.keys(email_list).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/addordeleteloadlogemail' && disableSaveCancel) {
            item.isFormDirty = true;
          } else if (item.navTo === '/addordeleteloadlogemail')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disableSaveCancel || email_list]);

  // handle close and confirm popup
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/addordeleteloadlogemail' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/addordeleteloadlogemail' && item.isFormSave) {
          item.isFormSave = false;
          saveLogEmailDelete(true);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  React.useEffect(() => {
    if (pendingLeftGridUpdate !== null && emailTypeAssignedTbl.length === 0) {
      dispatch(emailLogDetailData(pendingLeftGridUpdate));
      setPendingLeftGridUpdate(null);
      setLoad(false) 
    }
  }, [pendingLeftGridUpdate, emailTypeAssignedTbl, dispatch]);
  const [pendingRightGridUpdate, setPendingRightGridUpdate] = React.useState(null);
  React.useEffect(() => {
    if (pendingRightGridUpdate !== null && emailTypeAvailableTbl.length === 0) {
      dispatch(emailLogRightGrid(pendingRightGridUpdate));
      setPendingRightGridUpdate(null);
      setLoad(false); 
    }
  }, [pendingRightGridUpdate, emailTypeAvailableTbl, dispatch]);
  
  React.useEffect(() => {
    if (
      pendingEmailLogDetail &&
      rightEmailgridTbl.length === 0 &&
      leftEmailgridTbl.length === 0
    ) {
      dispatch(emailLogDetailData(pendingEmailLogDetail));
      setPendingEmailLogDetail(null);
    }
  }, [pendingEmailLogDetail, rightEmailgridTbl, leftEmailgridTbl, dispatch]);
  React.useEffect(() => {
    if (pendingEmailListUpdate !== null && emailListTbl.length === 1 && emailListTbl[0].email === '' && emailListTbl[0].emailType === '') {
      dispatch(emailListData(pendingEmailListUpdate, true));
      setPendingEmailListUpdate(null);
    }
  }, [pendingEmailListUpdate, emailListTbl, dispatch]);
  return (
    <div className="tabs-container" data-testid="AddorDeleteLoadLogEmail">
      <Spinner load={load} />
      <CustomSeparator
        parent1="System"
        parent2="Online Fixes"
        parent3="Add or Delete Load Log Email"
      />
      <SaveCancelPopup
        open={open}
        data-testid="savePopup"
        title="Save"
        onConfim={() => {
          saveLogEmailDelete(false);
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid="cancelPopup"
        title="Cancel"
        onConfim={() => {
          resetAllFields();
        }}
        onCancel={() => {
          setOpenCancel(false);
        }}
      />
      <SaveCancelPopup
        open={openDelete}
        title="Delete"
        moduleName="the selected record"
        onConfim={() => {
          setOpenDelete(false);
          deleteEmail();
        }}
        onCancel={() => {
          setOpenDelete(false);
        }}
      />
      {!emailListFull && !leftFull && !rightFull ? (
        <DisplaySuccessMessages successMessages={sucessMessage} />
      ) : null}
      {!emailListFull && !leftFull && !rightFull ? (
        <div className="row mb-2">
          <div className="col-12 pl-0">
            <div className="btn-wrapper float-right mt-2 mb-2">
              <Button
                className="btn btn-success btn-save"
                data-testid="open_Add"
                onClick={() => {
                  setOpen(true);
                }}
                disabled={!disableSaveCancel}
              >
                <SVGComponent iconName="Icon-awesome-save" />
                Save
              </Button>
              <Button
                className="btn btn-cancel"
                data-testid="open_cancel"
                onClick={() => {
                  setOpenCancel(true);
                }}
                disabled={!disableSaveCancel}
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
          </div>
        </div>
      ) : null}
      <ErrorMessages errorMessages={errorMessage} />
      <div class="row">
        {!leftFull && !rightFull ? (
          <div class={!emailListFull ? 'col-4' : 'col-12'}>
            <TableGrid
              data-testid="email-table"
              rowData={emailListTbl}
              gridCall={onLeftGridReady}
              enableFocusOnFirstRender={true}
              selectRowIndex={0} 
              columnDefs={emailTablehead}
              fullScreenView={emailListFull}
              handleFullScreenViewClick={() => setEmailListFull(!emailListFull)}
              gridHeight={emailListFull ? '70vh' : 340}
              rowSelection="single"
              fileName="Email Address"
              exportFile
              onSelectionChanged={onSelectionChangedEmail}
              addButtonText="Add Email"
              handleAddNewRow={handleAddNewRow}
              frameworkComponents={{
                EmailAddressCellRender: (cellInfo) => {
                  const email_list = useSelector(
                    (state) =>
                      state?.sharedState?.AddorDeleteLoadLogEmailReducer
                        ?.email_list
                  );
                  const handleChange = (e) => {
                    const newObj = [...email_list];
                    cellInfo.node.setDataValue('email', e.target.value);
                    setNewSelectedEmail(e.target.value);
                  };
                  return (
                    <div data-testid="email-text-box">
                      {cellInfo?.data?.emailNew ? (
                        <div className="email-text-box">
                          <TextField
                            placeholder=""
                            name="Email Address"
                            value={cellInfo?.data?.email}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxlength: 50 }}
                            onChange={handleChange}
                            onBlur={handleChange}
                          />
                          <div className="dlt-btn-display tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="delete-tooltip">Delete</Tooltip>
                              }
                            >
                              <Button
                                data-testid="deleteBtn"
                                className="th-ic trash-blue"
                                variant="text"
                                onClick={() => {
                                  setOpenDelete(true);
                                }}
                                aria-label="Delete"
                              >
                                <SVGComponent iconName="Icon-delete" />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </div>
                      ) : (
                        <div>
                          {' '}
                          <div className="emailDisplay">
                            {cellInfo?.data?.email}
                          </div>
                          <div className="dlt-btn-display tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="delete-tooltip">Delete</Tooltip>
                              }
                            >
                              <Button
                                data-testid="deleteBtn"
                                className="th-ic trash-blue"
                                variant="text"
                                onClick={() => {
                                  setOpenDelete(true);
                                }}
                                aria-label="Delete"
                              >
                                <SVGComponent iconName="Icon-delete" />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                },
              }}
            />
          </div>
        ) : null}

        {!emailListFull ? (
          <div
            class={!leftFull && !rightFull ? 'col-8 mt-2' : 'col-12 mt-2'}
            style={{ display: 'flex' }}
          >
            {!rightFull && (
              <div style={!leftFull ? { width: '47%' } : { width: '100%' }}>
                <ErrorMessages errorMessages={[]} />
                <TableGrid
                  data-testid="Email Type Assigned"
                  rowData={emailTypeAssignedTbl}
                  gridCall={onLeftAssignedGridReady}
                  columnDefs={leftTableHead}
                  fullScreenView={leftFull}
                  handleFullScreenViewClick={() => setLefFull(!leftFull)}
                  gridHeight={leftFull ? '70vh' : 340}
                  rowSelection="multiple"
                  fileName="Email Type Assigned"
                  exportFile
                  onSelectionChanged={onSelectionChangedLeft}
                />
              </div>
            )}

            {!leftFull && !rightFull && (
              <div className="ndcsTableSection task_request_claim">
                <div className="ndcTableBtn">
                  <Button
                    className="btn-primary frr-arrow-button"
                    onClick={moveToRight}
                    aria-label="single data forward"
                    data-testid="move-left-to-right-btn"
                    tabIndex={0}
                  >
                    <i
                      className="fa fa-light fa-caret-right"
                      aria-hidden="true"
                    />
                  </Button>
                  <Button
                    className="btn-primary"
                    onClick={moveToLeft}
                    aria-label="single data backward"
                    data-testid="move-right-to-left-btn"
                    tabIndex={0}
                  >
                    <i
                      className="fa fa-light fa-caret-left"
                      aria-hidden="true"
                    />
                  </Button>
                </div>
              </div>
            )}
            {!leftFull && (
              <div style={!rightFull ? { width: '47%' } : { width: '100%' }}>
                <ErrorMessages errorMessages={[]} />
                <TableGrid
                  data-testid="Email Type Available"
                  rowData={emailTypeAvailableTbl}
                  columnDefs={rightTableHead}
                  fullScreenView={rightFull}
                  handleFullScreenViewClick={() => setRightFull(!rightFull)}
                  gridHeight={rightFull ? '70vh' : 340}
                  rowSelection="multiple"
                  gridCall={onRightGridReady}
                  onSelectionChanged={onSelectionChangedRight}
                  fileName="Email Type Available"
                  exportFile
                />
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AddorDeleteLoadLogEmail;
